/** Moldura de entrar: no computador, o painel berinjela com o que ela ganha à esquerda e o formulário à direita. */
import { type ReactNode, useEffect, useState } from 'react';
import { IconBell, IconLink, IconWallet } from '../../components/Icons';
import semana from './assets/semana.webp';
import './entrar.css';

/** A moldura dividida vale do tablet deitado para cima (1000 px); abaixo disso, uma coluna. */
const DESKTOP = '(min-width: 1000px)';

export function useMedia(query: string): boolean {
  const [matches, setMatches] = useState(() => window.matchMedia(query).matches);
  useEffect(() => {
    const mq = window.matchMedia(query);
    const on = () => setMatches(mq.matches);
    on();
    mq.addEventListener('change', on);
    return () => mq.removeEventListener('change', on);
  }, [query]);
  return matches;
}

export function useDesktop(): boolean {
  return useMedia(DESKTOP);
}

export function Brand({ dark = false }: { dark?: boolean }) {
  return (
    <span className={`en-brand${dark ? ' en-brand--dark' : ''}`}>
      <img src="/icons/icon.svg" alt="" width={44} height={44} />
      Lindeza
    </span>
  );
}

/** No computador envolve o formulário; no celular e no tablet devolve a tela como está. */
export function EntrarShell({ children }: { children: ReactNode }) {
  const desktop = useDesktop();
  if (!desktop) return <>{children}</>;
  return (
    <div className="en-dk">
      <section className="en-dk-panel" aria-label="O que você ganha">
        <Brand dark />
        <h1 className="en-dk-t">
          <span>Abra sua agenda.</span> <span>Sua cliente marca sozinha.</span>
        </h1>
        <ul className="en-dk-gains">
          <li>
            <IconLink />A cliente escolhe o horário pelo seu link.
          </li>
          <li>
            <IconBell />O app lembra a cliente pelo WhatsApp.
          </li>
          <li>
            <IconWallet />
            Você vê quanto entrou no mês.
          </li>
        </ul>
        <figure className="en-dk-shot">
          <img src={semana} alt="A agenda do Lindeza no computador: a semana inteira, com a cliente de agora em destaque" width={880} height={480} />
        </figure>
      </section>
      <main className="en-dk-side">
        <div className="en-dk-form">{children}</div>
      </main>
    </div>
  );
}
